import styled from 'styled-components'
import { Save, Plus, CirclePlus } from 'lucide-react'

const ActionButtons = ({
	onAddButtonPress,
	onSaveButtonPress,
	pageHasUnsavedChanges,
}) => {
	return (
		<StyledContainer>
			<StyledButton onClick={onAddButtonPress}>
				Neuer Eintrag
				<CirclePlus />
			</StyledButton>
			<StyledButton
				onClick={onSaveButtonPress}
				$hasChanges={pageHasUnsavedChanges()}
				disabled={!pageHasUnsavedChanges()}
			>
				Speichern
				<Save />
			</StyledButton>
		</StyledContainer>
	)
}
// Styled Components
const StyledButton = styled.button`
	padding: 14px;
	background-color: ${(props) => (props.$hasChanges ? '#EC4E20' : '#016FB9')};
	opacity: ${(props) => (props.disabled && !props.$hasChanges ? 0.6 : 1)};
	color: white;
	border: none;
	border-radius: 8px;
	font-size: 22px;
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
	align-items: center;
	display: flex;
	gap: 8px;
	transition: all 0.2s ease-in-out;
	&:hover:not(:disabled) {
		filter: brightness(1.1);
		transform: translateY(-1px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	}
	&:active:not(:disabled) {
		transform: translateY(0);
	}
`

const StyledContainer = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
padding-left: 16px;
padding-top: 16px;
`
export default ActionButtons
